webpackJsonp([6],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ry+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0cub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"financingChain"},[_c('el-row',{staticClass:"financingChain_container"},[_c('el-col',{staticClass:"panel-top",attrs:{"span":24}},[_c('div',{staticClass:"container"},[(!_vm.isSupervisionMode)?_c('el-dropdown',{staticClass:"global-drop-down",attrs:{"placement":"top-start","hide-on-click":false},on:{"command":_vm.handleCommand}},[_c('GlobalIcon',{staticClass:"global-icon"}),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.languages),function(item,index){return _c('el-dropdown-item',{key:index,class:{
                  'dropdown-item-active': item.languageCode == _vm.currentLanguage
                },attrs:{"command":item.languageCode}},[_vm._v("\n                "+_vm._s(item.languageName)+" ("+_vm._s(item.languageDisplayName)+")\n              ")])}),1)],1):_vm._e(),_vm._v(" "),_c('el-col',{staticClass:"head_left",attrs:{"span":8}},[(_vm.isSupervisionMode)?_c('span',{staticClass:"logo",on:{"click":function($event){return _vm.$router.push({ path: '/aboutUs' })}}},[_c('img',{attrs:{"src":__webpack_require__("1QZ/")}})]):_c('span',{staticClass:"logo",on:{"click":function($event){return _vm.$router.push({ path: '/home' })}}},[_c('img',{attrs:{"src":__webpack_require__("1QZ/")}})])]),_vm._v(" "),_c('el-col',{staticClass:"menu-list",attrs:{"span":16}},[(!_vm.isSupervisionMode)?_c('span',{staticClass:"menu_item",class:_vm.selectIndex == 1 ? 'active' : '',on:{"click":function($event){return _vm.$router.push({ path: '/home' })}}},[_vm._v(_vm._s(_vm.$t("主页")))]):_vm._e(),_vm._v(" "),(!_vm.isSupervisionMode)?_c('el-popover',{attrs:{"popper-class":"servicePover","placement":"bottom","trigger":"hover"},model:{value:(_vm.showService),callback:function ($$v) {_vm.showService=$$v},expression:"showService"}},[_c('div',{staticClass:"selectList"},[_c('div',{staticClass:"selectItem",class:_vm.activeServiceIndex === 0 ? 'activeService' : '',on:{"click":function($event){return _vm.changeService(0)}}},[_vm._v("\n                  "+_vm._s(_vm.$t("核心企业"))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"selectItem",class:_vm.activeServiceIndex === 1 ? 'activeService' : '',on:{"click":function($event){return _vm.changeService(1)}}},[_vm._v("\n                  "+_vm._s(_vm.$t("供应商"))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"selectItem",class:_vm.activeServiceIndex === 2 ? 'activeService' : '',on:{"click":function($event){return _vm.changeService(2)}}},[_vm._v("\n                  "+_vm._s(_vm.$t("增值服务"))+"\n                ")])]),_vm._v(" "),_c('span',{staticClass:"menu_item menu_item_service",class:_vm.selectIndex == 2 ? 'active' : '',attrs:{"slot":"reference"},on:{"click":function($event){_vm.activeServiceIndex = 0;
                  _vm.$emit('changeService', 0);
                  _vm.$router.push({ path: '/service' });}},slot:"reference"},[_vm._v("\n                "+_vm._s(_vm.$t("产品服务"))+"\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.isSupervisionMode)?_c('span',{staticClass:"menu_item",class:_vm.selectIndex == 3 ? 'active' : '',on:{"click":function($event){return _vm.$router.push({ path: '/news' })}}},[_vm._v(_vm._s(_vm.$t("新闻动态")))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"menu_item last",class:_vm.selectIndex == 4 ? 'active' : '',on:{"click":function($event){return _vm.$router.push({ path: '/aboutUs' })}}},[_vm._v(_vm._s(_vm.$t("关于我们")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showService || _vm.$route.name != 'service'),expression:"!showService || $route.name != 'service'"}],staticClass:"line",class:{ 'centered-line': _vm.isSupervisionMode }}),_vm._v(" "),(!_vm.isSupervisionMode)?[_c('el-dropdown',{staticClass:"new-login",attrs:{"hide-on-click":false}},[_c('span',{staticClass:"el-dropdown-link login-btn"},[_vm._v("\n                  "+_vm._s(_vm.$t("登录 | 注册"))),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.toLogin('supplier')}}},[_vm._v(_vm._s(_vm.$t("供应商系统")))]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.toLogin('fund')}}},[_vm._v(_vm._s(_vm.$t("资金方系统")))]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.toLogin('core')}}},[_vm._v(_vm._s(_vm.$t("核心企业系统")))])],1)],1)]:_vm._e()],2)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1QZ/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "website_front_static/img/logo.68c461a.png";

/***/ }),

/***/ "3QXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("NKi3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79bff89a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("CQa9");
function injectStyle (ssrContext) {
  __webpack_require__("bApH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79bff89a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8z31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CQa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"panel",class:_vm.selectIndex == 1 ? 'homePanel' : ''},[_c('header-component',{attrs:{"selectIndex":_vm.selectIndex},on:{"changeService":_vm.changeService}}),_vm._v(" "),_c('router-view',{attrs:{"seviceIndex":_vm.seviceIndex},on:{"changeService":_vm.changeService}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63052dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("0cub");
function injectStyle (ssrContext) {
  __webpack_require__("jgDD")
  __webpack_require__("vPHw")
  __webpack_require__("/ry+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63052dec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63052dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dzb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iun5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LL4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MtQs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "website_front_static/fonts/element-icons.535877f.woff";

/***/ }),

/***/ "N4h9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  language: {
    language: '语言',
    zh: '中国',
    en: '英国'
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_message_css__ = __webpack_require__("cwe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message__ = __webpack_require__("2X9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Index__ = __webpack_require__("3QXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js_method_js__ = __webpack_require__("idHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js_resourceExt_vue_plugin_js__ = __webpack_require__("o8lu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang__ = __webpack_require__("cEaa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_css_common_less__ = __webpack_require__("tWcW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_css_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_css_common_less__);




// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__common_js_method_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__common_js_resourceExt_vue_plugin_js__["a" /* default */]);

// 按需引入的组件会自动注册，无需手动Vue.use()
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message___default.a;


__WEBPACK_IMPORTED_MODULE_11_axios___default.a.defaults.withcredentials = true;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_11_axios___default.a;

/**
 * 统一设置后台请求地址
 * 设置请求地址：config文件夹下的request.json
 */
//axios.defaults.baseURL = process.env._BASEURL
/** 统一设置后台请求地址 */
if (false) {
  //本地开发地址
  axios.defaults.baseURL = "http://localhost:8084/dev";
  // axios.defaults.baseURL = "https://www.rongechain.com";
} else {
  //测试地址
  // axios.defaults.baseURL = 'https://recf.sit.sf-express.com:45391'

  // axios.defaults.baseURL = 'http://caihuilian.sit.sf-express.com:46001'
  //生产地址
  __WEBPACK_IMPORTED_MODULE_11_axios___default.a.defaults.baseURL = "";
  // axios.defaults.baseURL = 'https://www.caihuichain.com'
  // axios.defaults.baseURL = 'https://www.rongechain.com'
}
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_11_axios___default.a;

//POST传参序列化(添加请求拦截器)，该序列化方式也是根据实际情况加与不加
__WEBPACK_IMPORTED_MODULE_11_axios___default.a.interceptors.request.use(function (config) {
  //在发送请求之前如果为post序列化请求参数
  /*if(config.method === 'post') {
  config.data = qs.stringify(config.data);
  }*/
  config.headers["language"] = localStorage.getItem("lang");
  return config;
}, function (error) {
  sfopenVM.$toast.show({
    text: __WEBPACK_IMPORTED_MODULE_10__lang__["a" /* default */].t("传参错误，请检查！"),
    type: "text",
    time: 1000,
    width: "auto"
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

function isWhiteList(url) {
  var whiteList = ["/official/outer/international/supportLanguage", "/official/outer/international/frontLanguageFiles"];
  var flag = false;
  whiteList.forEach(function (item) {
    if (url.indexOf(item) !== -1) {
      flag = true;
    }
  });
  return flag;
}
//返回状态判断(添加响应拦截器)
__WEBPACK_IMPORTED_MODULE_11_axios___default.a.interceptors.response.use(function (res) {
  //对响应数据做判断，与后台协议统一接口返回格式
  if (res.data.succ != "ok" && res.data.code != 200 && !isWhiteList(res.config.url)) {
    console.log("res.config.url", res.config.url);
    //这个判断可根据实际情况修改
    sfopenVM.$toast.show({
      text: res.data.msg ? res.data.msg : __WEBPACK_IMPORTED_MODULE_10__lang__["a" /* default */].t("服务器请求失败，请重试！"),
      type: "text",
      time: 3000,
      width: "auto"
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
  }
  return res;
}, function (error) {
  var msg = __WEBPACK_IMPORTED_MODULE_10__lang__["a" /* default */].t("网络异常，请稍后再试！");
  sfopenVM.$toast.show({
    text: msg,
    type: "text",
    time: 1500,
    width: "auto"
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});


__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (document.getElementsByClassName("panel")[0]) {
    document.getElementsByClassName("panel")[0].scrollTop = 0;
  }
  window.scroll(0, 0);
  next();
});
/* eslint-disable no-new */
/*new Vue({
	router,
	el: '#web',
	render: h => h(Index)
})*/
var sfopenVM;
sfopenVM = new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  el: "#web",
  i18n: __WEBPACK_IMPORTED_MODULE_10__lang__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__Index__["a" /* default */]);
  }
});

/***/ }),

/***/ "NKi3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    headerComponent: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */]
  },
  watch: {
    $route: "viewpage"
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      selectIndex: 1,
      seviceIndex: 0
    };
  },
  mounted: function mounted() {
    // 监管模式下强制跳转到关于我们
    if (window.websiteMode === "supervision" && this.$route.name !== "aboutUs") {
      this.$router.replace({ path: "/aboutUs" });
    }
    switch (this.$route.name) {
      case "home":
        this.selectIndex = 1;
        break;
      case "service":
        this.selectIndex = 2;
        break;
      case "news":
        this.selectIndex = 3;
        break;
      case "newsDetail":
        this.selectIndex = 3;
        break;
      case "aboutUs":
        this.selectIndex = 4;
        break;
    }
  },

  methods: {
    changeService: function changeService(val) {
      //切记服务页面选项
      this.seviceIndex = val;
    },

    viewpage: function viewpage() {
      // 监管模式下强制跳转到关于我们
      if (window.websiteMode === "supervision" && this.$route.name !== "aboutUs") {
        this.$router.replace({ path: "/aboutUs" });
        this.selectIndex = 4;
        return;
      }
      switch (this.$route.name) {
        case "home":
          this.selectIndex = 1;
          break;
        case "service":
          this.selectIndex = 2;
          break;
        case "news":
          this.selectIndex = 3;
          break;
        case "newsDetail":
          this.selectIndex = 3;
          break;
        case "aboutUs":
          this.selectIndex = 4;
          break;
      }
    }
  }
});

/***/ }),

/***/ "U/ZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/home",
    name: "home",
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "E27G"));
    }
  }, {
    path: "*",
    redirect: "/home"
  }, {
    path: "/aboutUs",
    name: "aboutUs",
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Hehd"));
    }
  }, {
    path: "/service",
    name: "service",
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "ICU+"));
    }
  }, {
    path: "/news",
    name: "news",
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "lODA"));
    }
  }, {
    path: "/newsDetail",
    name: "newsDetail",
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "/tMT"));
    }
  }]
}));

/***/ }),

/***/ "YiW1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "website_front_static/fonts/element-icons.732389d.ttf";

/***/ }),

/***/ "bApH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cEaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__("Vi3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_TW__ = __webpack_require__("gwsl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_en_js__ = __webpack_require__("p9le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_zh_js__ = __webpack_require__("N4h9");



 // 引入国际化的包

 // 引入饿了么的英文包

 // 引入饿了么的中文包

 // 引入饿了么的繁体包







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]); // 全局注册国际化包

var lang = localStorage.getItem('lang');
var code = 'zh-CN';
if (lang) {
  code = lang;
}

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: code, // 从cookie中获取语言类型 获取不到就是中文
  silentTranslationWarn: true,
  fallbackLocale: 'zh-CN',
  messages: {
    'en-US': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__lang_en_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default.a),

    'zh-CN': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__lang_zh_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN___default.a),
    'zh-TW': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_TW___default.a)
  }
});
__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default.a.i18n(function (key, value) {
  return i18n.t(key, value);
});
/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ "cwe7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d/b4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"f-s-20 anticon anticon-global",attrs:{"data-v-7b52f5a1":"","aria-label":"icon: global"}},[_c('svg',{attrs:{"viewBox":"64 64 896 896","data-icon":"global","width":"1em","height":"1em","fill":"currentColor","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":"M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d7TW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e/0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf16c8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalIcon_vue__ = __webpack_require__("d/b4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf16c8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "idHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_element_ui_common__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_element_ui_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_element_ui_common__);




/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    var fromDisable = true; //表单可提交状态
    // 1. 添加全局方法或属性
    /*Vue.myGlobalMethod = function() {
    // 逻辑...
    alert(1);
    }
    // 2. 添加全局资源
    Vue.directive('my-directive', {
    bind(el, binding, vnode, oldVnode) {
    // 逻辑...
    }
    })
    // 3. 注入组件
    Vue.mixin({
    created: function() {
    // 逻辑...
    }
    })*/
    /**
     * @author：ww
     * @function: 对象深度拷贝
     * @pramas: obj 需要拷贝的对象 必填
     * 			obj2 拷贝生成的对象(默认返回对象，如果是数组需要传,eg:function(obj,[])) 非必填
     */
    Vue.prototype.$extendDeepCopy = function (obj, obj2) {
      var newobj = obj2 || {};
      for (var i in obj) {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj[i]) === "object" && obj[i] !== null) {
          newobj[i] = obj[i].constructor === Array ? [] : {};
          this.$extendDeepCopy(obj[i], newobj[i]);
        } else {
          newobj[i] = obj[i];
        }
      }
      return newobj;
    },
    /**
    * @author：ww
    * @function: 时间格式化
    * @pramas: 1."times": 可以为秒或者毫秒，必填
       2."formatStr": 返回时间格式 非必填
    */
    Vue.prototype.$format = function (times, formatStr) {
      if (/^\d{12,14}$/.test(times)) {
        var timestamp = times;
      } else if (/^\d{9,11}$/.test(times)) {
        var timestamp = times * 1000;
      } else {
        return times;
      }
      var format = formatStr || "yyyy/MM/dd";
      var currentDate = new Date(parseInt(timestamp));
      var date = {
        "M+": currentDate.getMonth() + 1,
        "d+": currentDate.getDate(),
        "h+": currentDate.getHours(),
        "m+": currentDate.getMinutes(),
        "s+": currentDate.getSeconds()
      };
      if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
      }
      return format;
    },
    /**
     * @author：ww
     * @function: 人员单选选择框
     * @pramas: el-autocomplete 必须基于这个控件使用
     */
    Vue.prototype.$singlePersonSelect = function (queryString, cb) {
      var that = this;
      if (/^[\u4e00-\u9fa5]/g.test(queryString) || /^\d{3,}$/.test(queryString)) {
        this.timeOut && clearTimeout(this.timeOut);
        this.timeOut = setTimeout(function () {
          that.$httpExt().post("common/queryEmp", {
            pageNum: 1,
            pageSize: 10,
            likeStr: queryString
          }).then(function (response) {
            var results = response.result.list;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(results.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var index = _ref2[0];
                var item = _ref2[1];

                item.value = item.lastName + "(" + item.empNum + ")";
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            cb(results);
          }, function (response) {
            Object(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_element_ui_common__["Message"])({
              message: response.msg,
              type: "warning"
            });
          });
        }, 500);
      } else {
        cb([]);
      }
    },
    /**
     * @author：ww
     * @function: 组织单选选择框
     * @pramas: el-autocomplete 必须基于这个控件使用
     */
    Vue.prototype.$singleOrgSelect = function (queryString, cb) {
      var that = this;
      if (/^[\u4e00-\u9fa5]/g.test(queryString) || /^[A-Za-z0-9]{2,}$/.test(queryString)) {
        this.timeOut && clearTimeout(this.timeOut);
        this.timeOut = setTimeout(function () {
          that.$httpExt().post("common/queryOrg", {
            paging: 1,
            pageNum: 1,
            pageSize: 10,
            likeStr: queryString,
            region: "all"
          }).then(function (response) {
            var results = response.result.list;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(results.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _ref3 = _step2.value;

                var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                var index = _ref4[0];
                var item = _ref4[1];

                item.value = item.orgName;
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            cb(results);
          }, function (response) {
            Object(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_element_ui_common__["Message"])({
              message: response.msg,
              type: "warning"
            });
          });
        }, 500);
      } else {
        cb([]);
      }
    },
    /**
     * @author：xmj
     * @function: 防重
     * @pramas: btn  可传可不传 传了btn置灰
     */
    Vue.prototype.$checkPrevent = function (btn) {
      if (fromDisable) {
        // 验证表单状态是否为可以提交状态
        fromDisable = false; // 点击后 把状态改为 不可提交
        setTimeout(function () {
          fromDisable = true;
        }, 3000); // 三秒之后把表单状态重新设置为可提交
        if (typeof btn != "undefined") {
          // 验证是否传入值
          btn.style.background = "#ddd"; // 把按钮颜色置灰
          btn.style.color = "#fff"; // 把按钮颜色置灰
          btn.style.border = 0; // 把按钮颜色置灰
          setTimeout(function () {
            btn.style.background = "";
            btn.style.color = "";
            btn.style.border = "";
          }, 3000); // 三秒后重新改为启用
        }
        return true; // 如果状态为可提交 返回true
      } else {
        return false;
      }
    }, Vue.prototype.$getCookie = function (name) {
      var data = document.cookie;
      var dataArray = data.split("; ");
      for (var i = 0; i < dataArray.length; i++) {
        var varName = dataArray[i].split("=");
        if (varName[0] === name) {
          return decodeURI(varName[1]);
        }
      }
    }, Vue.prototype.$delAllCookie = function () {
      var myDate = new Date();
      myDate.setTime(-1000); //设置时间
      var data = document.cookie;
      var dataArray = data.split("; ");
      for (var i = 0; i < dataArray.length; i++) {
        var varName = dataArray[i].split("=");
        document.cookie = varName[0] + "=''; expires=" + myDate.toGMTString();
      }
    };
  }
});

/***/ }),

/***/ "jZDA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jgDD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lrka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("cEaa");



var setLanguage = function setLanguage(langCode) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/official/outer/international/frontLanguageFiles', { responseType: 'blob' }).then(function (res) {
      var reader = new FileReader();
      reader.readAsText(res.data);
      reader.onload = function (e) {
        var data = JSON.parse(e.target.result);
        __WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */].locale = langCode;
        __WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */].mergeLocaleMessage(langCode, data);
        document.title = __WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */].t('才汇链科技（深圳）有限公司');
        resolve();
      };
    });
  });
};

/***/ }),

/***/ "o8lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang__ = __webpack_require__("cEaa");



//import store from 'store'
//import cookieUtil from './util/cookie'


var jumpFlag = true;

var action = function action(url, method, dat, opt) {
	var data = dat || {};
	var option = opt || {};
	option.headers = option.headers || {};
	option.headers['SfopenReferer'] = window.location;
	option.withCredentials = true;
	var promise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		var req = void 0;
		if (/^p/.test(method)) {
			req = __WEBPACK_IMPORTED_MODULE_2_axios___default.a[method](url, data, option);
		} else {
			option.params = data;
			req = __WEBPACK_IMPORTED_MODULE_2_axios___default.a[method](url, option);
		}
		req.then(function (response) {
			//NOSONAR
			var tmp = response.data;
			if (typeof tmp === 'string') {
				try {
					tmp = JSON.parse(tmp);
				} catch (e) {}
			}
			if (tmp.succ.toLowerCase() === "ok") {
				resolve(tmp);
			} else if (tmp.succ.toLowerCase() === "jump") {
				if (jumpFlag && tmp.result.redirect) {
					jumpFlag = false;
					window.location.href = tmp.result.redirect;
				}
			} else {
				reject(tmp);
			}
		}, function () {
			reject({ msg: __WEBPACK_IMPORTED_MODULE_3__lang__["a" /* default */].t("网络异常，请刷新页面或者联系系统管理员！") });
		});
	});
	return promise;
};

var httpExt = {
	put: function put(url, data, option) {
		return action(url, 'put', data, option);
	},
	putForm: function putForm(url, data, option) {
		var opt = option || {};
		opt.headers = {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		};
		opt.emulateJSON = true;
		return action(url, 'put', data, opt);
	},
	post: function post(url, data, option) {
		return action(url, 'post', data, option);
	},
	postJson: function postJson(url, data, option) {
		return action(url, 'post', data, option);
	},
	postForm: function postForm(url, data, option) {
		var opt = option || {};
		opt.headers = {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		};
		opt.emulateJSON = true;
		return action(url, 'post', data, opt);
	},
	get: function get(url, data, option) {
		/**添加时间戳,防止ie有缓存*/
		var data2 = data ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { time: new Date().getTime() }) : data;
		return action(url, 'get', data2, option);
	},
	delete: function _delete(url, data, option) {
		return action(url, 'delete', data, option);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		//axios.defaults.baseURL = store.state.global.url
		//本地开发地址
		//axios.defaults.baseURL = 'http://10.118.12.18:809/'
		//sit地址
		//axios.defaults.baseURL ='http://osfp.sit.sf-express.com/'
		//PRD地址
		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = 'http://osfp.sf-express.com/';
		Vue.prototype.$axios = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;
		Vue.prototype.$httpExt = function () {
			return httpExt;
		};
	}
});

/***/ }),

/***/ "p9le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  language: {
    language: 'language',
    zh: 'china',
    en: 'english'
  }
});

/***/ }),

/***/ "tWcW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vPHw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wqBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_icon_css__ = __webpack_require__("Iun5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_icon__ = __webpack_require__("ttjG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_popover_css__ = __webpack_require__("8z31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_popover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_popover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_popover__ = __webpack_require__("SXzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_col_css__ = __webpack_require__("jZDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col__ = __webpack_require__("91Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__globalIcon__ = __webpack_require__("e/0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lang_switchLanuage__ = __webpack_require__("lrka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios__);





















//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// 注册Element组件
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_popover___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_icon___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sfwHeader",
  props: ["selectIndex"],
  components: { GlobalIcon: __WEBPACK_IMPORTED_MODULE_16__globalIcon__["a" /* default */] },
  data: function data() {
    return {
      activeServiceIndex: 0,
      showService: false,
      isSupervisionMode: window.websiteMode === "supervision",
      languages: [],
      currentLanguage: localStorage.getItem("lang") || "zh-CN"
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_18_axios___default.a.get("/official/outer/international/supportLanguage").then(function (res) {
      _this.languages = res.data || [];
      var lang = localStorage.getItem("lang");
      if (!lang) {
        lang = "zh-CN";
      }
      Object(__WEBPACK_IMPORTED_MODULE_17__lang_switchLanuage__["a" /* setLanguage */])(lang);
    });
  },

  methods: {
    selectIndexChange: function selectIndexChange(val) {
      if (this.isSupervisionMode) {
        return;
      }
      var line = document.getElementsByClassName("line")[0];
      if (!line) return;
      if (val == 1) {
        line.style.left = "196px";
        line.style.right = "466px";
      } else if (val == 2) {
        line.style.left = "290px";
        line.style.right = "370px";
      } else if (val == 3) {
        line.style.left = "400px";
        line.style.right = "256px";
      } else if (val == 4) {
        line.style.left = "516px";
        line.style.right = "146px";
      } else {
        line.style.display = "none";
      }
    },
    changeService: function changeService(index) {
      this.activeServiceIndex = index;
      // 修复控制台报重复的"/service"错误，因此注释下面跳转的代码
      // this.$router.push({ path: "/service" });
      this.$emit("changeService", index);
    },
    toRegister: function toRegister() {
      window.location.href = "/signup";
    },
    toLogin: function toLogin(name) {
      if (name === "supplier") {
        window.open(window.loginUrl && window.loginUrl.supplier + "?langCode=" + this.currentLanguage, "_blank");
      } else if (name === "fund") {
        window.open(window.loginUrl && window.loginUrl.fund + "?langCode=" + this.currentLanguage, "_blank");
      } else if (name === "core") {
        window.open(window.loginUrl && window.loginUrl.core + "?langCode=" + this.currentLanguage, "_blank");
      }
    },
    handleCommand: function handleCommand(languageCode) {
      localStorage.setItem("lang", languageCode);
      this.currentLanguage = languageCode;
      Object(__WEBPACK_IMPORTED_MODULE_17__lang_switchLanuage__["a" /* setLanguage */])(languageCode).then(function () {
        // window.location.reload();
      });
    }
  },
  watch: {
    selectIndex: "selectIndexChange"
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// website_front_static/js/app.61637c6ebdf45c838869.js